/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import NumericalDivInput from '../../../components/keyboard/NumericalDivInput';
import TimepickerDivInput from '../../../components/keyboard/TimepickerDivInput';
import KeyboardDivInput from '../../../components/keyboard/KeyboardDivInput';
import CloseButton from '../../../components/buttons/CloseButton';
import {setReportTransactionVisibleForm, createBarReportTransactions} from '../../../../common/menu/report/transaction/actions';
import {setField} from '../../../../common/lib/redux-fields/actions';
import {removeErrors} from '../../../../common/app/actions';
import CashboxDivInput from './CashboxDivInput';

class NewPopup extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        page: React.PropTypes.number,
        limit: React.PropTypes.number,
        barId: React.PropTypes.number,
        transactionTypes: React.PropTypes.object,
        defaultCashboxId: React.PropTypes.number,
        fields: React.PropTypes.object,
        transactionType: React.PropTypes.string,
        setReportTransactionVisibleForm: React.PropTypes.func,
        createBarReportTransactions: React.PropTypes.func
    };

    constructor(props) {
        super(props);

        this.transactionName = this.transactionName.bind(this);
        this.onChangeForm = this.onChangeForm.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    transactionName() {
        const {transactionType, transactionTypes, msg} = this.props;
        switch (transactionType) {
            case transactionTypes.INCOME: {
                return msg.transactions.income;
            }
            case transactionTypes.OUTCOME: {
                return msg.transactions.outcome;
            }
            case transactionTypes.TRANSFER: {
                return msg.transactions.transfer;
            }
        }
        return '';
    }

    onFormSubmit() {
        const {fields, createBarReportTransactions, transactionType, barId, limit, page} = this.props;

        const destination = fields.getIn('destination');
        const origin = fields.getIn('origin');
        const title = fields.getIn('title');
        const date = fields.getIn('date');
        const amount = fields.getIn('amount');
        const documentNumber = fields.getIn('documentNumber');
        const note = fields.getIn('note');

        createBarReportTransactions({destination, origin, title, date, amount, documentNumber, note},
            transactionType, barId, limit, page);
    }

    onChangeForm(name, value) {
        const {setField} = this.props;
        setField(name, value);
    }

    isValid() {
        const {fields, transactionType, transactionTypes} = this.props;

        if (typeof fields.getIn('destination') === 'undefined'
            || typeof fields.getIn('origin') === 'undefined'
            || typeof fields.getIn('title') === 'undefined'
            || typeof fields.getIn('date') === 'undefined'
            || typeof fields.getIn('amount') === 'undefined'
            || typeof fields.getIn('documentNumber') === 'undefined'
            ) {
            return false;
        }

        if (transactionType === transactionTypes.TRANSFER) {
            if (fields.getIn('origin') === null) {
                return false;
            }
        }

        if (fields.getIn('origin') === fields.getIn('destination')) {
            return false;
        }

        return !(fields.getIn('destination') === null
                || fields.getIn('title').length === 0
                || fields.getIn('date').length === 0
                || fields.getIn('amount').length === 0
                || fields.getIn('amount') <= 0);

    }

    componentWillMount() {
        const {setField, removeErrors, defaultCashboxId, transactionType, transactionTypes} = this.props;
        removeErrors();

        if (transactionType !== transactionTypes.TRANSFER) {
            setField('destination', defaultCashboxId);
            setField('origin', null);
        } else {
            setField('destination', null);
            setField('origin', defaultCashboxId);
        }

        setField('title', '');
        setField('note', '');
        setField('date', Date.now());
        setField('documentNumber', '');
        setField('amount', '');
    }

    componentWillUnmount() {
        const {setReportTransactionVisibleForm} = this.props;
        setReportTransactionVisibleForm(false);
    }

    render() {
        const {setReportTransactionVisibleForm, transactionType, transactionTypes, fields, msg} = this.props;

        if (typeof fields.getIn('origin') === 'undefined') {
            return null;
        }

        return (
            <div className="popup new-transaction">
                <div className="popup-block">
                    <div className="popup-content">
                        <div className="popup-inner">
                            <h1 className="popup-title">
                                {msg.transactions.new}: {this.transactionName()}
                            </h1>
                          <div className="popup-list">
                            <div className="popup-list-key">
                              <div className="form view-small">
                                <KeyboardDivInput value={fields.getIn('title')}
                                                  label={msg.transactions.name}
                                                  title={`${msg.transactions.name}*`}
                                                  className="input"
                                                  onSubmit={(val) => this.onChangeForm('title', val)} />
                              </div>
                            </div>
                                {transactionType === transactionTypes.TRANSFER &&
                                <div className="popup-list-key">
                                  <div className="form view-small">
                                <CashboxDivInput title={msg.transactions.fromCashbox}
                                                 onSubmit={(val) => this.onChangeForm('origin', val)}
                                                 className="input"
                                                 value={fields.getIn('origin')}/>
                                </div>
                                </div>
                                }
                                {transactionType === transactionTypes.TRANSFER &&
                                  <div className="popup-list-key">
                                    <div className="form view-small">
                                <CashboxDivInput title={msg.transactions.toCashbox}
                                                 onSubmit={(val) => this.onChangeForm('destination', val)}
                                                 className="input"
                                                 value={fields.getIn('destination')}/>
                                  </div>
                                  </div>
                                }
                                {transactionType !== transactionTypes.TRANSFER &&
                                <div className="popup-list-key">
                                  <div className="form view-small">
                                <CashboxDivInput title={msg.transactions.cashbox}
                                                 onSubmit={(val) => this.onChangeForm('destination', val)}
                                                 className="input"
                                                 value={fields.getIn('destination')}/>
                                </div>
                                </div>
                                }
                            <div className="popup-list-key">
                              <div className="form view-small">
                                <NumericalDivInput value={fields.getIn('amount')}
                                                   label={msg.transactions.amount}
                                                   onSubmit={(val) => this.onChangeForm('amount', val)}
                                                   className="input"
                                                   title={`${msg.transactions.amount}*`}/>
                              </div>
                            </div>

                            <div className="popup-list-key">
                              <div className="form view-small">
                                <KeyboardDivInput value={fields.getIn('documentNumber')}
                                                  title={msg.transactions.idNumber}
                                                  label={msg.transactions.idNumber}
                                                  className="input"
                                                  onSubmit={(val) => this.onChangeForm('documentNumber', val)} />
                            </div>
                            </div>

                            <div className="popup-list-key">
                              <div className="form view-small">
                                <KeyboardDivInput value={fields.getIn('note')}
                                                  title={msg.transactions.note}
                                                  label={msg.transactions.note}
                                                  className="input"
                                                  onSubmit={(val) => this.onChangeForm('note', val)} />
                            </div>
                            </div>

                            <div className="popup-list-key">
                              <div className="form view-small">
                                <TimepickerDivInput value={fields.getIn('date')}
                                                    onSubmit={(val) => this.onChangeForm('date', val)}
                                                    className="input"
                                                    label={msg.transactions.time}
                                                    title={`${msg.transactions.time}*`}/>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                  <div className="popup-controls">
                    <div className="popup-controls-key">
                        <div className="boxBtn color-white" onClick={() => setReportTransactionVisibleForm(false)}>
                            <CloseButton/>
                        </div>
                    </div>
                    <div className="popup-controls-key">
                        <div className={`boxBtn color-green ${this.isValid() ? '' : 'disabled'}`}
                             onClick={() => this.onFormSubmit()}>
                            <div className="boxBtn-inner">
                                <span>{msg.transactions.send}</span>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    barId: state.bars.getIn(['bar', 'id']),
    limit: state.transactions.get('limit'),
    page: state.transactions.get('page'),
    fields: state.fields,
    transactionType: state.transactions.get('transactionType'),
    transactionTypes: state.transactions.get('transactionTypes'),
    defaultCashboxId: state.cashboxes.getIn(['defaultCashbox', 'id'])
}), {setReportTransactionVisibleForm, removeErrors, setField, createBarReportTransactions})(NewPopup);



// WEBPACK FOOTER //
// ./src/browser/menu/report/transactions/NewPopup.js